"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var useSlotDetailsData_1 = __importDefault(require("./useSlotDetailsData"));
var useBrandDetailsData_1 = __importDefault(require("./useBrandDetailsData"));
var usePlayerSettings_1 = __importDefault(require("./usePlayerSettings"));
var useSelector_1 = __importDefault(require("./useSelector"));
exports.default = {
    useSlotDetailsData: useSlotDetailsData_1.default,
    useBrandDetailsData: useBrandDetailsData_1.default,
    useSelector: useSelector_1.default,
    usePlayerSettings: usePlayerSettings_1.default,
};
//# sourceMappingURL=index.js.map